import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from '@svenskaspelab/ui/react/card';
import type { PropsWithChildren, ReactNode } from 'react';
type PixWalletItemProps = PropsWithChildren<{
  title: string;
  description?: string;
  className?: string;
}>;

/**
 * Each coupon addition should be wrapped in this component to make sure correct sizing is applied
 * It renders a ui Card with the given title, description and children as content.
 *
 * @param root0 the input object
 * @param root0.children the content of this addition card
 * @param root0.className optional className for styling the card
 * @param root0.title title for the card
 * @param root0.description optional description of this card
 * @returns Component.
 */
export default function PixWalletItem(t0) {
  const $ = _c(15);
  const {
    children,
    className,
    title,
    description
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = ["bg-surface-standard w-full lg:w-full", className].filter(Boolean);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = t1.join(" ");
  let t3;
  if ($[2] !== title) {
    t3 = <h3 className="flex justify-center text-lg font-medium lg:justify-start">{title}</h3>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== description) {
    t4 = description && <div className="text-surface-fg-muted py-[6px] text-center text-sm lg:text-left">{description}</div>;
    $[4] = description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <header className="pb-[6px]">{t3}{t4}</header>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== t5) {
    t6 = <CardContent>{t5}{children}</CardContent>;
    $[9] = children;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t6) {
    t7 = <Card className={t2}>{t6}</Card>;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}